import React, { useState } from 'react';
import { SignOutButton, useUser, useAuth } from '@clerk/clerk-react';
import { AlertCircle, CreditCard, LogOut } from 'lucide-react';
import './PastDue.css';

const SERVER_URL = process.env.REACT_APP_SERVER_URL;

const PastDue = ({ subscriptionId }) => {
    const { user } = useUser();
    const { getToken, userId: username } = useAuth();
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');

    const handleUpdatePayment = async () => {
        setLoading(true);
        setError('');
        try {
            const token = await getToken();
            const response = await fetch(`https://${SERVER_URL}/api/create-billing-portal-session`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`,
                },
                body: JSON.stringify({ userId: username }),
            });

            if (!response.ok) throw new Error('Failed to create billing portal session');

            const { url } = await response.json();
            window.location.href = url;
        } catch (err) {
            console.error('Error opening billing portal:', err);
            setError('Could not open the billing portal. Please try again.');
            setLoading(false);
        }
    };

    return (
        <div className="past-due-container">
            <div className="past-due-card">

                <div className="past-due-icon-wrap">
                    <AlertCircle size={36} strokeWidth={1.8} />
                </div>

                <h1 className="past-due-title">Payment Failed</h1>
                <p className="past-due-text">
                    Your latest subscription payment didn't go through. Please update your payment
                    information to restore access to RevTrack.
                </p>

                {error && <p className="past-due-error">{error}</p>}

                <button
                    className="past-due-cta"
                    onClick={handleUpdatePayment}
                    disabled={loading}
                >
                    <CreditCard size={16} />
                    {loading ? 'Redirecting…' : 'Update Payment Information'}
                </button>

                <div className="past-due-footer">
                    <span className="past-due-email">
                        {user?.primaryEmailAddress?.emailAddress}
                    </span>
                    <SignOutButton>
                        <button className="past-due-signout">
                            <LogOut size={14} />
                            Sign out
                        </button>
                    </SignOutButton>
                </div>
            </div>
        </div>
    );
};

export default PastDue;
